import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsInReviewPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW;
    id: string;
    attributes: {
      data: Array<{
        days_in_review: string;
        request_count: number;
      }>;
      aggregate: {
        requests_in_review: InsightMetric;
      };
    };
  };
}

export const parseRequestsInReviewPayload = (
  payload: BaseInsightPayload
): RequestsInReviewPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW,
    data.attributes,
    true,
    true,
    ['requests_in_review']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      days_in_review: string;
      request_count: number;
    }>;
    aggregate: { requests_in_review: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_IN_REVIEW,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          requests_in_review: typedAttributes.aggregate.requests_in_review,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
